module.exports = __webpack_public_path__ + "img/empty-cart-2.37f6036f.png";